import { QueryFilter } from '@skippay/core/utils/apiUtils';

import { getPayInThreeQueryFilter } from 'utils/payInThreeUtils';

export const PAY_IN_THREE_ACTIVE_FILTER = getPayInThreeQueryFilter()
	.prop('isClosed')
	.eq('false')
	.toString();

export const INSTALLMENTS_ACTIVE_FILTER = new QueryFilter().prop('isActive').eq('true').toString();
